import apiService from '../Api'

export default class AbraMidiaService {
  async list(filter: { page?: number; pageSize?: number }) {
    return apiService.get('/abra-media', {
      params: {
        page: filter.page ?? 1,
        page_size: filter.pageSize ?? 10
      }
    })
  }

  async get(id: number) {
    return apiService.get(`/abra-media/${id}`)
  }

  async getByCode(code: string) {
    return apiService.get(`/abra-media/get-by-code/${code}`)
  }

  async store(data: { title: string; notes: string }) {
    return apiService.post('/abra-media', data)
  }

  async update(id: number, data: { title: string; notes: string }) {
    return apiService.put(`/abra-media/${id}`, data)
  }

  async uploadFile(data: { file: File; position: number; abraMediaId: number }) {
    const formData = new FormData()
    formData.append('file', data.file)
    formData.append('position', data.position.toString())

    return apiService.post(`/abra-media/${data.abraMediaId}/files`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }

  async updateFile(data: { abraMediaId: number; fileId: number; position: number }) {
    return apiService.put(`/abra-media/${data.abraMediaId}/files/${data.fileId}`, {
      position: data.position
    })
  }

  async removeFile(data: { abraMediaId: number; fileId: number }) {
    return apiService.delete(`/abra-media/${data.abraMediaId}/files/${data.fileId}`)
  }

  async delete(id: number) {
    return apiService.delete(`/abra-media/${id}`)
  }
}
